import { jsx, jsxs } from 'react/jsx-runtime';
import { useWindowSize, BREAKPOINTS_WIDTHS } from '@belong/common';
import clsx from 'clsx';
import css from './Stepper.module.css.js';

function Stepper({
  steps,
  onlyActiveLabel,
  onStepSelection
}) {
  const {
    width
  } = useWindowSize();
  const isMobile = width <= BREAKPOINTS_WIDTHS.MD;
  const activeStep = steps.find(step => step.active);
  const activeStepIndex = Math.max(steps.indexOf(activeStep), 0);
  // With a single visible label the steps carry no text to space, so the
  // track is split into equal cells; otherwise each cell hugs its label and
  // the gap between labels is constant.
  const isEqualTrack = isMobile || !!onlyActiveLabel;
  const onSelection = (step, index) => e => {
    e.stopPropagation();
    if (onStepSelection) onStepSelection(step, index);
  };
  const shouldShowLabel = step => {
    if (isMobile) {
      return step === activeStep;
    }
    return onlyActiveLabel && step === activeStep || !onlyActiveLabel;
  };
  return jsx("section", {
    className: "flex w-full flex-row",
    children: steps.map((step, index) => {
      const isStepCompleted = index < activeStepIndex;
      const isFirst = index === 0;
      const isLast = index === steps.length - 1;
      return jsxs("article", {
        className: clsx('relative flex flex-col items-center', {
          'flex-1': isEqualTrack,
          'flex-auto': !isEqualTrack,
          'cursor-pointer': !!onStepSelection
        }),
        onClick: onSelection(step, index),
        children: [jsx("div", {
          className: clsx('relative w-full', {
            'h-4': isEqualTrack,
            'mb-2xs px-md': !isEqualTrack
          }),
          children: shouldShowLabel(step) && jsx("div", {
            className: clsx('whitespace-nowrap text-center text-p2 leading-p2 text-navy', {
              'absolute bottom-0 left-1/2 -translate-x-1/2': isEqualTrack,
              'font-semibold': step.active || isStepCompleted
            }),
            children: step.label
          })
        }), jsxs("div", {
          className: clsx('relative w-full', css.progressBar),
          children: [jsx("div", {
            className: clsx('absolute inset-0 bg-gray', {
              'rounded-l': isFirst,
              'rounded-r': isLast
            })
          }), jsx("div", {
            className: clsx('absolute inset-y-0 left-0 bg-navy', {
              'w-full': isStepCompleted,
              'w-1/2': step.active,
              'w-0': !isStepCompleted && !step.active,
              'rounded-l': isFirst
            })
          }), jsx("div", {
            className: clsx('absolute left-1/2 top-1/2 h-2xs w-2xs -translate-x-1/2 -translate-y-1/2 rounded bg-green', {
              [`${css.active}`]: step.active
            })
          })]
        })]
      }, `${step.label}-${index}`);
    })
  });
}

export { Stepper };
